import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as commonActions } from "../../modules/commonModule"
import { formatDate } from "../../modules/utilities"
import { COLOR, CONSTANTS, LINKS } from "../../modules/constants"

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"

const trialMessage = [
  "YOUR TRIAL ENDS TODAY! - this is your last chance to try Numerable for free",
  "Your trial of a subscription to Numerable is running out - have you tried the use cases we describe? click the button below to read them",
  "The 2 rows at the bottom of a table show average and total figures for the values in the column above",
  "External links let you go directly to more information on the company or person you are viewing: Company website, Annual Report or accounts, Companies House, LinkedIn",
  "Export as CSV lets you output a file in comma-separated-variables format, to load into a spreadsheet like Excel or other software",
  "The Snapshot PDF feature generates an A4 snapshot to print or save as a summary of the company or person you are viewing",
  "If you select the Connections checkbox, you list the connected companies for a company (those that share a director) or the co-directors of a person",
  "The filter checkboxes on the LSE, COMPANY and PERSON pages let you select what you see in your list",
  "On the COMPANY and PERSON pages, the 3 View icons let you switch between different ways to visualise the information - try the Timeline view to see when each role starts and ends",
  "The COMPANY and PERSON pages let you view the directors of the company or board roles of the person, and then click through",
  "You can find any UK company or director by searching on the COMPANIES HOUSE page",
  "When viewing a table you can sort the rows by clicking on a column header",
  "On the LSE pages you can search, filter and browse to find UK listed public companies and their directors",
  "If you Register and Login to Numerable you can save companies and people to your Favourites, then quickly go back to them later",
]

const welcomeMessage = "Welcome to your trial of Numerable's subscription, which runs until "

// const longTrialMessage = "You have a long trial"

const expiredMessage = [
  "Your trial has now expired - we hope you found it useful",
  "You can continue to use Numerable for free with limited features and data",
  "Please contact us to discuss Numerable or request a subscription proposal",
  "- email "
]

// const websiteMessage = `There is more information about Numerable at <a href="https:numerable.io" target="_blank" rel="noopener noreferrer" >www.numerable.io</a>`

const invalidMessage = [
  "Your trial code appears to be invalid",
  "Please contact us to request a valid code - email "
]

// const questionsMessage = "Any questions? Contact us:"

const contactMessage = [
  "Please contact us to discuss Numerable or request a subscription proposal",
  "- email "
]

const phoneText = " or phone "
const phoneLink = <a href="tel:07866687154">0786 668 7154</a>
/*
  If the machine (or browser) doesn't have a default email client configured, nothing will happen.
  So emply Gmail option in case the user has no local mail client
*/
const emailLink = <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@numerable.io&su=Numerable" target="_blank" rel="noopener noreferrer">info@numerable.io</a>
const useCasesLink = `${LINKS.NUMERABLE.BASE}/home/saas/use-cases/?utm_medium=numapp&utm_campaign=trial`

class UrlTrialModal extends Component {

  render() {
    const { loading, daysLeft } = this.props

    const dontShowAgain = () => {
      this.props.common.setUrlTrialModalShown(true)
      return null
    }

    // find last day of trial
    const today = new Date()
    const lastDate = new Date(today.getTime() + (1000 * 60 * 60 * 24 * (daysLeft - 1)))
    const lastDateString = formatDate(lastDate, true)

    return (
      <React.Fragment>

        <Dialog
          disableRestoreFocus={true}
          open={true}
          maxWidth="sm" fullWidth>

          <DialogTitle>NUMERABLE TRIAL</DialogTitle>

          <DialogContent>
            {/* expired */}
            {daysLeft <= 0 && daysLeft != CONSTANTS.TRIAL_INVALID &&
              <React.Fragment>
                <DialogContentText>{expiredMessage[0]}</DialogContentText>
                <DialogContentText>{expiredMessage[1]}</DialogContentText>
                <DialogContentText>{expiredMessage[2]}</DialogContentText>
                <DialogContentText>{expiredMessage[3]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }

            {/* last day */}
            {daysLeft === 1 &&
              <React.Fragment>
                <DialogContentText>{welcomeMessage}{lastDateString}</DialogContentText>
                <DialogContentText>{trialMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[1]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }

            {/* in 14 day trial */}
            {daysLeft > 1 && daysLeft <= 14 &&
              <React.Fragment>
                <DialogContentText>{welcomeMessage}{lastDateString}</DialogContentText>
                <DialogContentText>You have {daysLeft} days left, including today</DialogContentText>
                <DialogContentText>TIP: {trialMessage[daysLeft - 1]}</DialogContentText>
                <DialogContentText>{contactMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[1]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }

            {/* in > 14 day trial */}
            {daysLeft > 14 && daysLeft <= 31 &&
              <React.Fragment>
                <DialogContentText>Welcome to your free Numerable trial</DialogContentText>
                <DialogContentText>You have {daysLeft} days left</DialogContentText>
                <DialogContentText>{contactMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[1]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }

            {/* invalid code */}
            {(daysLeft === CONSTANTS.TRIAL_INVALID || daysLeft > 31) &&
              <React.Fragment>
                <DialogContentText>{invalidMessage[0]}</DialogContentText>
                <DialogContentText>{invalidMessage[1]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }
          </DialogContent>

          <DialogActions>
            <Button target="_blank" href={useCasesLink} sx={{ color: COLOR.BRAND.STD }} >View use cases</Button>
            <Button variant="contained" disabled={loading} onClick={dontShowAgain} color="primary">Continue</Button>
          </DialogActions>

        </Dialog>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ common }) => {
  return {
    daysLeft: common.urlTrialDaysLeft,
    urlTrialModalShown: common.urlTrialModalShown,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    common: bindActionCreators(commonActions, dispatch),
  }
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(UrlTrialModal)

